import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=5392d1d0&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"
import style0 from "./Info.vue?vue&type=style&index=0&id=5392d1d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5392d1d0",
  null
  
)

export default component.exports